import ThemeMessage from "./ThemeMessage";

export default ThemeMessage;
